import { Spinner } from '@trp-beacon-ui-kit/react-communication';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import { displayShortDate } from '../../utils/utils';
import InboxZeroState from '../InboxZeroState/InboxZeroState';
import DeleteIcon from './DeleteIcon';
import styles from './Inbox.module.scss';

const cx = classnames.bind(styles);

const Inbox = ({
  baseUrl,
  hasTracOnly,
  messages,
  openModal,
  requestStatus,
  theme,
  transition
}) => {
  if (messages === undefined || messages === null || requestStatus < 0) {
    return (
      <div className={styles.loader}>
        <Spinner />
      </div>
    );
  }

  return (
    <div className={styles.inbox}>
      {messages.length ? (
        messages.map(
          ({ createdTimestamp, messageId, subject, viewed, ...message }) => (
            <div
              className={classnames(styles.row, 'row', 'branded-row', {
                'row-read': viewed
              })}
              key={messageId}
              onClick={() =>
                transition('select', {
                  baseUrl,
                  selectedMessage: {
                    createdTimestamp,
                    messageId,
                    subject,
                    viewed,
                    ...message
                  }
                })
              }
            >
              <a
                className={`${cx('subject', {
                  new: !viewed,
                  read: viewed
                })} branded-subject`}
                dangerouslySetInnerHTML={{ __html: subject }}
                id={messageId}
              ></a>
              <div className={`blocked_data ${styles['ie-spacer']}`} />
              <div
                className={`${cx('date', {
                  new: !viewed,
                  read: viewed
                })}
                branded-date`}
              >
                {displayShortDate(createdTimestamp,false,true)}
              </div>
              <div className={styles.delete}>
                <a
                  alt="delete"
                  className={`${cx('trash')} delete`}
                  id={`delete_${messageId}`}
                  onClick={e => {
                    e.stopPropagation();
                    const messageProps = {
                      createdTimestamp,
                      messageId,
                      subject,
                      viewed,
                      ...message
                    };
                    openModal({
                      message: { ...messageProps },
                      type: 'delete'
                    });
                  }}
                >
                  <DeleteIcon theme={theme} />
                </a>
              </div>
            </div>
          )
        )
      ) : (
        <InboxZeroState hasTracOnly={hasTracOnly}
                        transition={transition}/>
      )}
    </div>
  );
};

Inbox.propTypes = {
  baseUrl: PropTypes.string,
  hasTracOnly: PropTypes.bool,
  messages: PropTypes.arrayOf(PropTypes.object),
  openModal: PropTypes.func,
  requestStatus: PropTypes.number,
  theme: PropTypes.any,
  transition: PropTypes.func
};

export default Inbox;
